import { render, staticRenderFns } from "./addCRMNotes.vue?vue&type=template&id=010e9ee6"
import script from "./addCRMNotes.vue?vue&type=script&lang=js"
export * from "./addCRMNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports